import React from 'react'
import TabContent from '../TabContent.component'
import Need1 from "../../assets/need-1.svg";
import thumbImg from '../../assets/SolutionsImage/vectorImages/Swayam CRM Sales/fdgdf (1).jpg'

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;

export default function SswayamERPFeedbackManagement() {
    return (
        <>
            <section className="">
                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section >
                    <section>
                        <style>{css}</style>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className=" p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                            // ref={scrollRef}
                            >
                                <TabContent
                                    index={0}
                                    icon={Need1}
                                    thumbnail={thumbImg}
                                    title={"Feedback Management"}
                                    content={[
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sem enim, pharetra nec neque et, pulvinar ultrices purus. Curabitur egestas a ipsum eu accumsan. Vestibulum malesuada sed nulla et aliquam. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer viverra pretium mi et commodo."
                                        // "Sswayam CRM for Sales is a top-of-the-line CRM software designed specifically for sales teams. With this software, businesses can streamline their sales operations and keep everything unified in one platform. Managers can track the work of field agents, including expenses, daily sales reports, locations, leads collected, and more. The software provides real-time data and insights, empowering businesses to make data-driven decisions and improve their bottom line. Sswayam CRM is easy to use and has powerful features, including customizable dashboards, automated reports, and integrations with popular business tools.",
                                    ]}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </>
    )
}
